module.exports = function() {
  return new Worker(__webpack_public_path__ + "58b26ce40ad4aeb61087.worker.js");
};